var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 8C16.75 5.38 14.62 3.25 12 3.25C9.38 3.25 7.25 5.38 7.25 8V10.7C6.07 11.33 5.25 12.56 5.25 14V18C5.25 20.07 6.93 21.75 9 21.75H15C17.07 21.75 18.75 20.07 18.75 18V14C18.75 11.914 17.5953 10.25 15 10.25H9C8.91 10.25 8.83 10.27 8.75 10.28V8C8.75 6.21 10.21 4.75 12 4.75C14.2388 4.75 15.1751 6.30402 15.1574 7.99219C15.1574 7.99219 15.1602 8.59766 15.9258 8.60547C16.6914 8.61328 16.75 8 16.75 8ZM15 20.25C16.24 20.25 17.25 19.24 17.25 18V14C17.25 12.76 16.24 11.75 15 11.75H9C7.76 11.75 6.75 12.76 6.75 14V18C6.75 19.24 7.76 20.25 9 20.25H15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.75C11.59 14.75 11.25 15.09 11.25 15.5V17.5C11.25 17.91 11.59 18.25 12 18.25C12.41 18.25 12.75 17.91 12.75 17.5V15.5C12.75 15.09 12.41 14.75 12 14.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpened);
export default __webpack_public_path__ + "static/media/lock-opened.5ad2196e24cd67030c5b02ef89c9f2c6.svg";
export { ForwardRef as ReactComponent };